import { render, staticRenderFns } from "./OrderInfor.vue?vue&type=template&id=27e900e1"
import script from "./OrderInfor.vue?vue&type=script&lang=js"
export * from "./OrderInfor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports